import './checkout';
import './chosen';
import './commicons';
import './dropnav';
import './footer-accordion';
import './footer.ts';
import './init-cookieyes-script-manager';
import './init-lazy-load';
import './map';
import './option-selector';
import './placeholder';
import './polyfill-find';
import './replacementCovers';
import './searchbox';
import './windows-mobile';

if (document.querySelector('.blog-page')) {
  import('./blog');
}

if (document.querySelector('.category-seo')) {
  import('./category');
}

if (document.querySelector('.datepicker')) {
  import('./contact');
}

if (document.querySelector('.fancybox-media')) {
  import('./fancyBox');
}

if (document.querySelector('.growing-guides')) {
  import('./growing-guides');
}

if (document.querySelector('.home-seo')) {
  import('./home');
}

if (document.querySelector('.left-nav')) {
  import('./leftnav');
}

if (document.querySelector('.home-carousel, .polaroid')) {
  import('./owl');
}

if (document.querySelector('.product-details')) {
  import('./product-details');
}

if (document.querySelector('#MediaContainer')) {
  import('./social-hub');
}

if (document.querySelector('.js-tab')) {
  import('./tabs');
}

if (document.querySelector('.tel-no')) {
  import('./telno');
}

if (document.querySelector('.js-price-panel')) {
  import('./price-panel');
}
